<template>
    <div class="" style="max-width: 100%;">
        <!-- <div class="ios-tabs-header-wrapper">
            <div class="ios-segmented-control">
                <button class="ios-segmented-tab" :class="{ active: tab === 0 }" @click="tab = 0">
                    <v-icon class="mr-2" size="18">mdi-truck</v-icon>
                    Registro de Transportistas
                </button>
                <button class="ios-segmented-tab" :class="{ active: tab === 1 }" @click="tab = 1">
                    <v-icon class="mr-2" size="18">mdi-view-dashboard</v-icon>
                    Dashboard y Alertas
                </button>
                <div class="ios-segmented-slider" :style="{ transform: `translateX(${tab * 100}%)` }"></div>
            </div>
        </div> -->

        <v-tabs-items v-model="tab" style="background-color: transparent;" class="pt-0 mt-0">
            <v-tab-item>
                <s-crud title="Proveedores de Transporte" :filter="filter" searchInput height="450" :config="config" add
                    edit remove @rowSelected="rowSelected($event)" @addEvent="cleanFields()" @save="save($event)"
                    ref="crudcarriers">
                    <template slot-scope="props">
                        <v-card>
                            <v-row class="pa-3">
                                <v-col lg="3" md="6" sm="12" class="s-col-form" cols="12">
                                    <s-text v-model="carrier.SpcDocument" type="number" label="RUC"
                                        @keyupEnter="searchSunat($event)" :maxlength="11" />
                                </v-col>
                                <v-col lg="5" md="6" sm="12" class="s-col-form" cols="12">
                                    <s-text v-model="carrier.SpcCompanyName" label="Razón Social" />
                                </v-col>
                                <v-col lg="4" md="6" sm="12" class="s-col-form" cols="12">
                                    <s-text v-model="carrier.SpcDirection" label="Dirección" />
                                </v-col>
                            </v-row>
                        </v-card>
                    </template>

                    <template v-slot:SpcOptions="{ row }">
                        <div class="d-flex align-center" style="gap:8px;">
                            <v-tooltip bottom="">
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" x-small color="primary"
                                        style="padding-top: 12px;padding-bottom: 12px;" @click="openDialog(row)">
                                        <v-icon>mdi-file-document-outline</v-icon>
                                    </v-btn>
                                </template>
                                <span>documentos</span>
                            </v-tooltip>

                            <v-progress-linear :value="getProgreso(row)" height="12" :color="getColor(getProgreso(row))"
                                rounded class="white--text text-center" style="width: 100px;">
                            </v-progress-linear>
                            <span class="ml-2 text-caption font-weight-bold"
                                :class="`${getColor(getProgreso(row))}--text`">
                                {{ getProgreso(row) }}%
                            </span>
                        </div>

                        <!-- <v-progress-linear :value="getProgreso(row)" height="10" :color="getColor(getProgreso(row))"
                            rounded class="white--text text-center">
                            <template v-slot:default>
                                <strong style="font-size: 9px;">{{ getProgreso(row) }}%</strong>
                            </template>
                        </v-progress-linear> -->
                    </template>
                    <template v-slot:item.SpcDocument="{ item }">
                        <div class="font-weight-medium">{{ item.SpcCompanyName }}</div>
                        <div class="text-caption text--secondary">RUC: {{ item.SpcDocument }}</div>
                    </template>
                </s-crud>

                <!-- Modal de carga de archivos -->
                <SpcDocuments v-if="carrier.SpcID > 0" :SpcID.sync="carrier.SpcID" :dialogFiles.sync="dialogFiles">
                </SpcDocuments>
            </v-tab-item>

            <v-tab-item>
                <SpcCarriersDashboard />
            </v-tab-item>
        </v-tabs-items>
    </div>
</template>

<script>
import _SpcCarrierService from "@/services/SupplyChain/Transport/SpcCarrierService.js";
import _sSunarp from "@/services/General/SearchSunarp.js";
import _sDefinition from "@/services/General/DefinitionService.js";
import SpcDocuments from "./SpcDocuments.vue";
import SpcDocumentsTransport from "./SpcDocumentsTransport.vue";
import SpcCarriersDashboard from "./SpcCarriersDashboard.vue";

export default {
    components: { SpcDocuments, SpcDocumentsTransport, SpcCarriersDashboard },
    props: {
        close: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        tab: 0,
        filter: {
            Search: ''
        },
        dialogFiles: false,
        selected: [],
        config: {
            model: {
                SpcID: "ID",
                SpcDocument: "string",
                SpcCompanyName: "string",
                SpcCommercialName: "string",
                SpcDirection: "string",
                SecCreate: "date",
                SpcOptions: ""
            },
            service: _SpcCarrierService,
            headers: [
                // { text: "ID", value: "SpcID", width: 40, align: "center" },
                { text: "Transportista", value: "SpcDocument", },
                { text: "Dirección", value: "SpcDirection" },
                // { text: "Documentación (% Progreso)", value: "SpcOptions", align: 'center' },
                // { text: "Razón Social", value: "SpcCompanyName" },
            ],
        },
        carrier: {
            SpcID: 0,
            SpcDocument: '',
            SpcCompanyName: '',
            SpcCommercialName: '',
            SpcDirection: '',
            SecStatus: 1,
            UsrCreateID: 0,
        },
        typeFiles: [],
    }),
    methods: {
        searchSunat(value) {
            if (value == "" || value.length !== 11) {
                this.$fun.alert("Ingrese un documento válido", "warning");
                return;
            }

            _sSunarp.Search(value, this.$fun.getUserID()).then(resp => {
                if (resp.status == 200) {
                    this.carrier.SpcCompanyName = resp.data.SunName;
                    this.carrier.SpcDirection = resp.data.SunAddress;
                }
            })

        },
        rowSelected(item) {
            if (item && item.length > 0) {
                this.selected = item;
                this.carrier = { ...item[0] }
            }
        },
        save() {

            if (this.carrier.SpcDocument == "" || this.carrier.SpcDocument.length !== 11) {
                this.$fun.alert("Ingrese un documento válido", "warning");
                return;
            }
            if (this.carrier.SpcCompanyName == "") {
                this.$fun.alert("Ingrese razón social", "warning");
                return;
            }

            this.carrier.UsrCreateID = this.$fun.getUserID()
            _SpcCarrierService.save(this.carrier, this.$fun.getUserID()).then(result => {
                if (result.status == 200) {
                    this.$fun.alert("Registrado correctamente", "success");
                    this.$emit('refresh', result.data);
                    this.$refs.crudcarriers.refresh();
                    this.cleanFields();
                }
            })
        },

        cleanFields() {
            this.carrier = {
                SpcID: 0,
                SpcDocument: '',
                SpcCompanyName: '',
                SpcCommercialName: '',
                SpcDirection: '',
                SecStatus: 1,
                UsrCreateID: 0,
            }
        },

        getProgreso(item) {
            if (!item.CountDocuments) return 0;
            return Math.round((item.CountDocuments / this.typeFiles.length) * 100);
        },

        getColor(porcentaje) {
            if (porcentaje < 10) return "grey";
            if (porcentaje < 30) return "red";
            if (porcentaje <= 50) return "orange";
            if (porcentaje <= 70) return "yellow";
            if (porcentaje <= 90) return "primary";
            return "success";
        },

        async openDialog(data) {
            this.carrier = { ...data }
            this.dialogFiles = true;
        },

        async setTypeFiles() {
            const response = await _sDefinition.definitiongroup(1596, 0, this.$fun.getUserID());
            if (response.status == 200) {
                this.typeFiles = response.data.map((x, index) => ({
                    item: index + 1,
                    SpcdID: 0,
                    SpcID: 0,
                    SpcType: x.DedValue,
                    SpcTypeName: x.DedDescription,
                    SpcFilename: null,
                    attach: null,
                    SpcOthers: false,
                    SpcStartDate: null,
                    SpcExpireDate: null
                }))
                // console.log(this.typeFiles);
            }
        }
    },

    watch: {
        dialogFiles(value) {
            if (!value) {
                this.$refs.crudcarriers.refresh();
            }
        }
    },
    mounted() {
        this.setTypeFiles();
    }
};
</script>

<style scoped>
.gradient-primary {
    background: linear-gradient(135deg, #a4a4a4 29%, #322d38 100%);
}

.header-content {
    display: flex;
    gap: 8px;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.header-left {
    width: 100%;
    display: flex;
    gap: 8px;
    align-items: center;
    flex: 1 1 0%;
}

.header-right {
    display: flex;
    justify-items: center;
    align-items: center !important;
    min-width: 300px;
}

.search-field-header {
    padding: 8px;
    align-items: center !important;
    background-color: rgba(255, 255, 255, 0.15);
    border-radius: 1rem;
    max-width: 250px;
}

.search-field-header>>>.v-input__slot {
    background-color: rgba(255, 255, 255, 0.15) !important;
}

@media (max-width:768px) {
    .header-content {
        flex-direction: column;
    }

    .search-field-header {
        width: 100%;
        max-width: 80%;
    }
}

/* Center wrapper for the header */
.ios-tabs-header-wrapper {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-bottom: 12px;
    padding: 6px 0;
}

/* iOS Segmented Control custom component */
.ios-segmented-control {
    position: relative;
    display: inline-flex;
    background: rgba(118, 118, 128, 0.08);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border-radius: 12px;
    padding: 3px;
    width: 100%;
    max-width: 480px;
    height: 42px;
    border: 1px solid rgba(0, 0, 0, 0.04);
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.03);
    box-sizing: border-box;
    align-items: center;
}

.theme--dark .ios-segmented-control {
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.05);
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.15);
}

.ios-segmented-tab {
    position: relative;
    z-index: 2;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 34px;
    border: none;
    background: transparent;
    outline: none;
    font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    font-size: 0.88rem;
    font-weight: 500;
    letter-spacing: -0.2px;
    color: #8e8e93 !important;
    /* iOS system gray */
    border-radius: 9px;
    cursor: pointer;
    transition: color 0.25s ease, transform 0.2s cubic-bezier(0.16, 1, 0.3, 1);
    padding: 0 16px;
    text-transform: none !important;
}

.theme--dark .ios-segmented-tab {
    color: rgba(255, 255, 255, 0.5) !important;
}

.ios-segmented-tab:active {
    transform: scale(0.95) !important;
}

.ios-segmented-tab.active {
    color: #1c1c1e !important;
    /* iOS system dark gray */
    font-weight: 600;
    transform: scale(1) !important;
}

.theme--dark .ios-segmented-tab.active {
    color: #ffffff !important;
}

/* Moving Pill background slider with premium spring bounce animation */
.ios-segmented-slider {
    position: absolute;
    top: 3px;
    bottom: 3px;
    left: 3px;
    width: calc(50% - 3px);
    background: linear-gradient(180deg, #ffffff 0%, #fbfbfc 100%);
    border-radius: 9px;
    border: 0.5px solid rgba(0, 0, 0, 0.04);
    box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.04);
    z-index: 1;
    transition: transform 0.38s cubic-bezier(0.25, 1.3, 0.5, 1);
    /* iOS spring animation */
}

.theme--dark .ios-segmented-slider {
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.16) 0%, rgba(255, 255, 255, 0.12) 100%);
    border: 0.5px solid rgba(255, 255, 255, 0.08);
    box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.4), 0px 1px 3px rgba(0, 0, 0, 0.2);
}

.ios-segmented-tab .v-icon {
    font-size: 16px !important;
    margin-right: 8px !important;
    color: inherit !important;
    transition: transform 0.25s cubic-bezier(0.16, 1, 0.3, 1), color 0.25s ease !important;
}

@keyframes ios-pop {
    0% {
        transform: scale(0.8) translateY(0);
    }

    45% {
        transform: scale(1.18) translateY(-1px);
    }

    75% {
        transform: scale(0.95) translateY(0);
    }

    100% {
        transform: scale(1) translateY(0);
    }
}

.ios-segmented-tab.active .v-icon {
    animation: ios-pop 0.42s cubic-bezier(0.34, 1.56, 0.64, 1) both;
    color: #007aff !important;
}

.theme--dark .ios-segmented-tab.active .v-icon {
    color: #0a84ff !important;
}
</style>
